export default __webpack_public_path__ + "media/images/react_icons/ellipse-1803230600616a751fe47490b9ed1de4.svg";